export default __webpack_public_path__ + "static/media/space2.82d78546.svg";